import { useMemo } from 'react';
import { SOFTWARE_TABS, useRecommendationsTopicPreference } from '../../../features/recommendations';
import { usePreviouslySelectedTabStore } from '../../../features/recommendations/recommendationsStore';
import { useSavedLearningInterest } from '../../../features/wizard/wizardQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { jsx as _jsx } from "react/jsx-runtime";
export const useSoftwareRecommendationsTabs = () => {
  const {
    selectedCategoryGroup,
    selectedToolsGroup,
    hasLearningInterest,
    isLoadingLearningInterest
  } = useSavedLearningInterest();
  const {
    previouslySelectedTab
  } = usePreviouslySelectedTabStore();
  const {
    recommendationsTopicPreference,
    recommendationsTopicPreferenceLoading
  } = useRecommendationsTopicPreference();
  const {
    topic
  } = recommendationsTopicPreference || {};
  const recommendationsTopic = topic;
  const defaultSelectedTab = useMemo(() => {
    if (previouslySelectedTab) return previouslySelectedTab;else if (hasLearningInterest) {
      switch (selectedCategoryGroup || selectedToolsGroup) {
        case 'MARKETING':
        case 'MARKETING_HUB_TOOLS':
          return 'marketing';
        case 'SALES':
        case 'SALES_HUB_TOOLS':
          return 'sales';
        case 'SERVICE':
        case 'SERVICE_SUPPORT':
        case 'SERVICE_HUB_TOOLS':
          return 'services-support';
        default:
          return 'other';
      }
    } else if (recommendationsTopic && SOFTWARE_TABS.includes(recommendationsTopic)) {
      return recommendationsTopic;
    }
    return 'other';
  }, [previouslySelectedTab, hasLearningInterest, recommendationsTopic, selectedCategoryGroup, selectedToolsGroup]);
  const isLoading = isLoadingLearningInterest || recommendationsTopicPreferenceLoading;
  return {
    isLoading,
    defaultSelectedTab
  };
};
export const FeaturedSoftwareCoursesTabs = ({
  onSelectedChange,
  selectedTab
}) => {
  const handleSelectionChange = event => {
    onSelectedChange(event.target.value);
  };
  return /*#__PURE__*/_jsx(Tabs, {
    marginBlock: "400",
    onSelectedChange: handleSelectionChange,
    selected: selectedTab,
    children: SOFTWARE_TABS.map(tab => /*#__PURE__*/_jsx(Tab, {
      tabId: tab,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.featuredSoftwareCourses.tabs.${tab}`
      })
    }, `software_tab_${tab}`))
  });
};